import { FormControl, FormHelperText, InputBase, type InputBaseProps } from '@mui/material';
import { StyleObj } from '../../../../@types';
import { mergeSx } from '../../../../utils/styles';

export const styledFormInputStyles: StyleObj = {
  input: {
    backgroundColor: 'neutral.100',
    color: 'text.secondary',
    textAlign: 'center',
    width: '100%',
    '& .MuiInputBase-input': {
      padding: '4px 0 5px',
      textAlign: 'center',
      color: 'neutral.900',
    },
    '&.Mui-focused': {
      backgroundColor: 'neutral.50',
      outline: '3px solid',
      outlineColor: 'secondary.700',
    },
  },
  helperText: {
    textAlign: 'center',
  },
  numberInput: {
    '& .MuiInputBase-root': {
      backgroundColor: 'neutral.100',
    },
    '& .MuiInputBase-input': {
      padding: '4px 0 5px',
      textAlign: 'center',
      color: 'neutral.900',
    },
    '& .MuiInputBase-root.Mui-focused': {
      backgroundColor: 'neutral.50',
      outline: '3px solid',
      outlineColor: 'secondary.700',
    },
    '& .MuiFormHelperText-root': {
      textAlign: 'center',
    },
  },
};

type StyledFormInputProps = InputBaseProps & {
  helperText?: string;
};

const StyledFormInput = ({ helperText, sx, ...inputProps }: StyledFormInputProps) => (
  <FormControl fullWidth error={inputProps.error}>
    <InputBase {...inputProps} sx={mergeSx(styledFormInputStyles.input, sx)} />
    {helperText && <FormHelperText sx={styledFormInputStyles.helperText}>{helperText}</FormHelperText>}
  </FormControl>
);

export default StyledFormInput;
